import React from "react";

function OtpIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#FFF7E6" rx="8"></rect>
      <path
        stroke="#FA8C16"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M11.44 13.752h.117m4.443 0h.117m4.324 0h.117m-5.058 4.5H9.778A1.778 1.778 0 018 16.474V11.03c0-.982.796-1.778 1.778-1.778h12.444c.982 0 1.778.796 1.778 1.778v2.722m-5.157 3.58l1.158-.58a3 3 0 012.683 0l1.159.58v2.787c0 .962-.89 1.612-2.5 2.629-1.61-1.017-2.5-1.875-2.5-2.63v-2.787z"
      ></path>
    </svg>
  );
}

export default OtpIcon;